import type { Settings } from 'core/domains';
import { Utilities } from 'core/domains';

import { staticRoutes } from './static-routes';

export const initialState = {
  data: {
    featureToggle: {
      creditCardForm: true,
      shippingModel: true,
      buyIntention: true,
    },
    routes: staticRoutes,
    messages: {
      'catalog.product.badge.launch': 'Lançamento',
      'catalog.product.badge.promotion': 'Promoção',
      'catalog.product.badge.novelty': 'Novidade',
      'catalog.product.badge.sample': 'Demonstradores',
      'catalog.product.badge.bazaar': 'Bazar',
      'catalog.product.badge.recommendation': 'Recomendações',
      'catalog.product.badge.combo': 'Combo',
    },
  },
  message: '',
  status: Utilities.STATUS.IDLE,
  updatedAt: 0,
} as Settings;
